import React, { useEffect, useRef, useContext, useState } from "react";
import {
	Button,
	Table,
	Form,
	Input,
	Upload,
	Select,
	message,
} from "antd";
import { useModel } from "../../../models";
import SaleItemSelectionModel from "./SaleItemSelectionModel";
import { v4 as uuidV4 } from "uuid";
import {
	DICT_KEY,
	getDictNameByCode,
	formatNum,
	ENV
} from "../../../utils/constants";
import SaleRoService from "./SaleRoService";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const EditableContext = React.createContext();

const EditableRow = ({ index, ...props }) => {
	const [form] = Form.useForm();
	return (
		<Form form={form} component={false}>
			<EditableContext.Provider value={form}>
				<tr {...props} />
			</EditableContext.Provider>
		</Form>
	);
};
const EditableCell = ({
	title,
	editable,
	children,
	dataIndex,
	record,
	handleSave,
	editList,
	column,
	selectList,
	...restProps
}) => {
	const [{ warehouseDict, positionDict }] = useModel("cmDict");
	const [editing, setEditing] = useState(false);
	const [newPositionDict, setNewPositionDict] = useState([]);
	const [ware, setWare] = useState({});
	const [shelf, setShelf] = useState({});

	const inputRef = useRef();
	const form = useContext(EditableContext);
	useEffect(() => {
		if (editing) {
			// console.log(record);
			inputRef.current.focus();
			let goodsList = positionDict
				.filter((el) => el.warehouseId === record.warehouseId)
				.map((el) => ({
					key: el.key,
					label: el.label,
					value: el.value,
				}));
			setNewPositionDict(goodsList);
		}
	}, [editing]);

	const onKeyDown = async (event, isDefault = false) => {
		let node = event.target;
		let trParentNode = node.closest("tr");
		let checkRow = 1; //这里查看表格是否为多选状态
		let findIndex = editList.findIndex((item) => item.id == record.id);
		let findInd = column.findIndex((item) => item.dataIndex == dataIndex);
		if (event.keyCode === 40 && findIndex !== editList.length - 1) {
			trParentNode.nextSibling.children[findInd + checkRow].children[0].click();
		}
		if (event.keyCode === 38 && findIndex !== 0) {
			trParentNode.previousSibling.children[
				findInd + checkRow
			].children[0].click();
		}
		if (event.keyCode === 9) {
			event.stopPropagation();
			event.preventDefault();
			let reducerArr = column.reduce((cur, pre, index) => {
				if (pre.editable) {
					cur.push(index + checkRow);
				}
				return cur;
			}, []);
			let subscript = reducerArr.indexOf(findInd + checkRow);
			if (subscript === reducerArr.length - 1) {
				trParentNode.children[reducerArr[0]].children[0].click();
			} else {
				trParentNode.children[reducerArr[subscript + 1]].children[0].click();
			}
		}
		if (event.keyCode === 13) {
			event.stopPropagation();
			const values = await form.validateFields();
		}
	};

	const toggleEdit = () => {
		setEditing(!editing);
		form.setFieldsValue({
			[dataIndex]: record[dataIndex],
		});
	};

	const save = async (e) => {
		try {
			const values = await form.validateFields();
			// console.log(values);
			toggleEdit();
			let warehouseName = "",
				shelfCode = "";
			warehouseName = JSON.stringify(ware) != "{}" ? ware.label : record.warehouseName;
			shelfCode = JSON.stringify(shelf) != "{}" ? shelf.label : record.shelfCode;
			handleSave({ ...record, ...values, warehouseName, shelfCode });
		} catch (errInfo) {
			console.log("Save failed:", errInfo);
		}
	};
	const onChange1 = (value, option) => {
		// console.log(value, option);
		setWare(option);
	};
	const onChange2 = (value, option) => {
		setShelf(option);
	};
	const onFocus = () => {
		inputRef.current.select();
	};
	let childNode = children;

	const isNumber = (rule, value, callback) => {
		if (!Number.isFinite(value - 0)) {
			return Promise.reject("请输入数字");
		}
		return Promise.resolve();
	};
	const inputRules = (dataIndex) => {
		if (dataIndex === "returnNum") {
			return [
				{ required: true, message: `不能为空.` },
				{ validator: isNumber, trigger: "blur" },
				() => ({
					validator: (_, value) => {
						return value &&
							parseInt(value) > 0 &&
							parseInt(value) <=
							parseInt(record["saleNum"]) - parseInt(record["returnedNum"])
							? Promise.resolve()
							: Promise.reject("本次退货数量大于0且小于等于未退货数量");
					},
				}),
			];
		} else if (
			dataIndex === "returnDesc" ||
			dataIndex === "warehouseId" ||
			dataIndex === "shelfId"
		) {
			return [{ required: true, message: `不能为空.` }];
		} else if (dataIndex === "returnPrice") {
			return [
				{ required: true, message: `不能为空.` },
				{ validator: isNumber, trigger: "blur" },
			];
		} else if (dataIndex === "discount") {
			return [
				{ required: true, message: `不能为空.` },
				{ validator: isNumber, trigger: "blur" },
				{
					pattern: /^(([0-9]\d?)|100)$/g,
					message: "折扣必须是大于等于0且小于等于100的整数",
				},
			];
		}
	};
	const inputTypes = (dataIndex, record) => {
		if (dataIndex === "returnNum") {
			return (
				<Input
					ref={inputRef}
					onPressEnter={save}
					onBlur={save}
					onFocus={onFocus}
					style={{ width: "100%" }}
					onKeyDown={(e) => onKeyDown(e, true)}
					min={1}
					max={parseInt(record["saleNum"]) - parseInt(record["returnedNum"])}
				/>
			);
		} else if (dataIndex === "returnPrice") {
			return (
				<Input
					ref={inputRef}
					onPressEnter={save}
					onBlur={save}
					onFocus={onFocus}
					style={{ width: "100%" }}
					onKeyDown={(e) => onKeyDown(e, true)}
				/>
			);
		} else if (dataIndex === "discount") {
			return (
				<Input
					ref={inputRef}
					onPressEnter={save}
					onBlur={save}
					onFocus={onFocus}
					style={{ width: "100%" }}
					formatter={(value) => `${value}%`}
					parser={(value) => value.replace("%", "")}
					onKeyDown={(e) => onKeyDown(e, true)}
				/>
			);
		} else if (dataIndex === "returnDesc") {
			return (
				<Input.TextArea
					ref={inputRef}
					onBlur={save}
					style={{ width: "100%" }}
					onKeyDown={onKeyDown}
				/>
			);
		} else if (dataIndex === "warehouseId") {
			return (
				<Select
					ref={inputRef}
					showSearch
					allowClear={true}
					placeholder=""
					onBlur={save}
					onChange={onChange1}
					filterOption={(input, option) =>
						(option && option.label && option.label.indexOf(input)) >= 0
					}
					options={warehouseDict.map((el) => ({
						key: el.key,
						value: el.value,
						label: el.label,
					}))}
					onKeyDown={onKeyDown}
				// onInputKeyDown={onkeydown}
				/>
			);
		} else if (dataIndex === "shelfId") {
			return (
				<Select
					ref={inputRef}
					showSearch
					allowClear={true}
					placeholder=""
					onBlur={save}
					onChange={onChange2}
					filterOption={(input, option) =>
						(option && option.label && option.label.indexOf(input)) >= 0
					}
					options={newPositionDict.map((el) => ({
						key: el.key,
						value: el.value,
						label: el.label,
					}))}
					onKeyDown={onKeyDown}
				// onInputKeyDown={onkeydown}
				/>
			);
		}
	};
	if (editable) {
		childNode = editing ? (
			<Form.Item
				style={{
					margin: 0,
				}}
				name={dataIndex}
				rules={inputRules(dataIndex)}
			>
				{inputTypes(dataIndex, record)}
			</Form.Item>
		) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
					}}
					onClick={toggleEdit}
				>
					{children}
				</div>
			);
	}

	return <td {...restProps}>{childNode}</td>;
};

export default function ({ getForm }) {
	const [
		{
			selectedDocument,
			documentMaterialList,
			selectedDocumentMaterialRowKeys,
			detailStatistics,
		},
		{
			setDocumentMaterialList,
			removeDocumentMaterial,
			downloadDetailTpl,
			setSelectedDocumentMaterialRowKeys,
			setAddMaterialModelVisible,
			setDetailStatistics,
		},
	] = useModel("saleRo");
	const [{ warehouseDict, positionDict }] = useModel("cmDict");

	const { orderStatus = "029001" } = selectedDocument;
	//财务确认
	const editable01 = orderStatus === "029001" || orderStatus === "029002";
	//库房确认
	const editable02 = orderStatus === "029001";
	useEffect(() => {
		let saleTotalNum = 0,
			returnTotalNum = 0,
			returnTotalAmount = 0.0,
			payableTotalAmount = 0.0;
		documentMaterialList.forEach((el) => {
			const { saleNum, returnNum, payableAmount, returnPrice } = el;
			saleTotalNum = saleTotalNum + (saleNum ? parseInt(saleNum) : 0);
			returnTotalNum = returnTotalNum + (returnNum ? parseInt(returnNum) : 0);
			payableTotalAmount =
				payableTotalAmount + (payableAmount ? parseFloat(payableAmount) : 0.0);
			returnTotalAmount =
				returnTotalAmount +
				(!!returnNum && !!returnPrice
					? parseInt(returnNum) * parseFloat(returnPrice)
					: 0.0);
		});
		setDetailStatistics({
			saleTotalNum,
			returnTotalNum,
			payableTotalAmount: payableTotalAmount.toFixed(2),
			returnTotalAmount: returnTotalAmount.toFixed(2),
		});
	}, [documentMaterialList]);
	const handleSave = (row) => {
		setDocumentMaterialList(
			documentMaterialList.map((el) => {
				if (el.key === row.key) {
					let tmp = { ...el, ...row };
					const { returnNum, returnPrice, discount } = tmp;
					tmp.returnAmount = (returnNum * returnPrice).toFixed(2);
					tmp.payableAmount = (
						(returnNum * returnPrice * discount) /
						100
					).toFixed(2);
					return tmp;
				} else {
					return el;
				}
			})
		);
	};

	const TableHeader = () => {
		const onAdd = () => {
			getForm()
				.validateFields()
				.then((data) => {
					setAddMaterialModelVisible(true);
				})
				.catch((ex) => {
					message.error("请输入主表单信息!");
				});
		};
		const onDelete = () => {
			removeDocumentMaterial(selectedDocumentMaterialRowKeys);
		};

		const onDownloadTpl = () => {
			downloadDetailTpl({ showMsg: true, data: {} });
		};

		const onUploadSuccess = (retData) => {
			const mappedList = retData.map((el) => ({
				...el,
				key: uuidV4(),
				materialUnitName: getDictNameByCode(
					DICT_KEY.CM_DICT.MATERIAL_UNIT,
					el.materialUnit
				),
				materialBrandName: getDictNameByCode(
					DICT_KEY.CM_DICT.BRAND,
					el.materialBrand
				),
			}));
			setDocumentMaterialList([...documentMaterialList, ...mappedList]);
		};

		return (
			<div style={{ margin: "0 0 8px", display: "flex" }}>
				<div className="detail-list-statistic color-primary">
					<span className="margin-left-8">
						销售总数量：{detailStatistics ? detailStatistics.saleTotalNum : 0}
					</span>
					<span className="margin-left-16">
						退货总数量：
            {detailStatistics ? detailStatistics.returnTotalNum : 0.0}
					</span>
					<span className="margin-left-16">
						折后总计：
            {detailStatistics ? detailStatistics.payableTotalAmount : 0.0}
					</span>
				</div>
				<div
					style={{ width: "460px", textAlign: "right" }}
					hidden={orderStatus === "029003" || orderStatus === "029004"}
				>
					<YhAuth resCode={ResourceAuthEnum.SR_ED_ADD_M}>
						<Button
							type="primary"
							onClick={onAdd}
						>新增商品 </Button>
					</YhAuth>
					<YhAuth resCode={ResourceAuthEnum.SR_ED_DEL_M}>
						<Button
							className="margin-left-8"
							onClick={onDelete}
							disabled={
								!(selectedDocumentMaterialRowKeys.length > 0)
							}
						>删除商品 </Button>
					</YhAuth>
					<YhAuth resCode={ResourceAuthEnum.SR_ED_IM}>
						<Upload {...SaleRoService.getImportDetailCfg({ onUploadSuccess })}>
							<Button
								className="margin-left-8"
							>导入</Button>
						</Upload>
					</YhAuth>
					<YhAuth resCode={ResourceAuthEnum.SR_ED_DLOAD}>
						<Button
							className="margin-left-8"
							onClick={onDownloadTpl}
						>下载模板  </Button>
					</YhAuth>
				</div>
			</div>
		);
	};

	const columns = [
		{
			title: "",
			width: 50,
			render: (text, record, index) => `${index + 1}`,
		},
		{
			title: "销售单号",
			width: 160,
			dataIndex: "saleCode",
			align: "left",
		},
		{
			title: "商品编号",
			width: 120,
			dataIndex: "materialCode",
			align: "left",
		},
		{
			title: "商品名称",
			width: 180,
			ellipsis: true,
			dataIndex: "materialName",
		},
		/*{
				title: '图号',
				width: 120,
				dataIndex: 'replaceNum',
			},*/
		/*{
				title: '单位',
				width: 80,
				dataIndex: 'materialUnitName',
			},*/
		{
			title: "销售数量",
			width: 80,
			dataIndex: "saleNum",
		},
		{
			title: "已退数量",
			width: 80,
			dataIndex: "returnedNum",
		},
		{
			title: "赠品数量",
			width: 80,
			dataIndex: "giftsNum",
		},
		{
			title: "退货数量*",
			width: 80,
			dataIndex: "returnNum",
			editable: editable02,
		},

		{
			title: "退货单价*",
			width: 140,
			dataIndex: "returnPrice",
			editable: editable01,
			render: (text) => formatNum(text),
		},
		{
			title: "折扣*",
			width: 100,
			dataIndex: "discount",
			editable: editable01,
			render: (text) => text + "%",
		},

		{
			title: "总计",
			width: 140,
			dataIndex: "payableAmount",
			render: (text) => formatNum(text),
			// render: (text, record) => (record.returnPrice * record.returnQuantity * record.discount / 100).toFixed(2),
		},
		{
			title: "仓库*",
			dataIndex: "warehouseId",
			width: 160,
			ellipsis: true,
			editable: editable02,
			render: (text, record) => record.warehouseName ?? "空",
		},
		{
			title: "货位*",
			dataIndex: "shelfId",
			width: 160,
			editable: editable02,
			render: (text, record) => record.shelfCode ?? "空",
		},
		{
			title: "备注*",
			width: 200,
			dataIndex: "returnDesc",
			editable: true,
			render: (text, record) => record.returnDesc ?? "空",
		},
	];

	const components = {
		body: {
			row: EditableRow,
			cell: EditableCell,
		},
	};
	const mapColumns = (handleSave) =>
		columns.map((col) => {
			if (!col.editable) {
				return col;
			}

			return {
				...col,
				onCell: (record) => ({
					record,
					editable: col.editable,
					dataIndex: col.dataIndex,
					title: col.title,
					prefix: col.prefix ?? "",
					suffix: col.suffix ?? "",
					selectList: col.selectList ?? [],
					handleSave,
					column: columns,
					editList: documentMaterialList,
				}),
			};
		});

	return (
		<>
			<TableHeader />
			<Table
				components={components}
				columns={mapColumns(handleSave)}
				dataSource={documentMaterialList}
				bordered
				pagination={false}
				rowClassName={() => "editable-row"}
				rowSelection={{
					type: "checkbox",
					onChange: (selectedRowKeys) => {
						setSelectedDocumentMaterialRowKeys(selectedRowKeys);
					},
					selectedRowKeys: selectedDocumentMaterialRowKeys,
				}}
				scroll={{ x: "max-content", y: 420 }}
			/>

			<SaleItemSelectionModel />
		</>
	);
}
